import { useAuth } from '../../contexts/AuthContext/AuthContext'

export default function Projects() {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return (
      <div>
        <h1>Authentication Required</h1>
        <p>Please log in to access projects.</p>
      </div>
    )
  }

  return (
    <div>
      <h1>Projects</h1>
      <p>Welcome to your projects!</p>
    </div>
  )
} 